export default "__VITE_ASSET__8bT1XpRA__"